// src/api/osrm.ts
import { API_URL } from './api';
import type { ModoTransporte } from './api';

export interface RutaOSRMGeometry {
  type: string;
  coordinates: [number, number][];
}

export const obtenerRutaOSRM = async (
  coordinates: [number, number][],
  modoTransporte: ModoTransporte = 'coche',
): Promise<RutaOSRMGeometry | null> => {
  const coordsString = coordinates.map(coord => coord.slice().reverse().join(',')).join(';');
  const url = `${API_URL}/osrm/route?coordinates=${encodeURIComponent(coordsString)}&mode=${encodeURIComponent(modoTransporte)}`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    if (data.code === 'Ok') {
      // Validar que las coordenadas son [number, number][]
      if (data.routes && data.routes.length > 0 && data.routes[0].geometry) {
        const geometry = data.routes[0].geometry;
        if (geometry.coordinates.every((coord: any[]) => coord.length === 2)) {
          return {
            type: geometry.type,
            coordinates: geometry.coordinates as [number, number][],
          };
        }
      }
      return null;
    } else {
      console.error('Error en la respuesta de OSRM:', data);
      return null;
    }
  } catch (error) {
    console.error('Error al obtener la ruta de OSRM:', error);
    return null;
  }
};
